__turbopack_context__.v({
  "className": "jetbrains_mono_5b83a6cb-module__auLaha__className",
  "variable": "jetbrains_mono_5b83a6cb-module__auLaha__variable",
});
